import { render, staticRenderFns } from "./AddSystem.vue?vue&type=template&id=60679392&scoped=true&"
import script from "./AddSystem.vue?vue&type=script&lang=js&"
export * from "./AddSystem.vue?vue&type=script&lang=js&"
import style0 from "./AddSystem.vue?vue&type=style&index=0&id=60679392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60679392",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VDialog,VImg})
